import {
	AfterContentInit,
	ChangeDetectorRef,
	ComponentFactory,
	ComponentFactoryResolver,
	ComponentRef,
	Directive,
	ElementRef,
	Input,
	OnDestroy,
	OnInit,
	ViewContainerRef
} from '@angular/core';
import {NgModel} from "@angular/forms";

// Rxjs
import {fromEvent, combineLatest, ReplaySubject, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

// Components
import {FangAutocompleteDropdownComponent} from "../fang-autocomplete-dropdown.component";

// Popper.js
import Popper from 'popper.js';

@Directive({selector: '[autoComplete][ngModel]'})
export class FangAutocompleteInputDirective implements AfterContentInit, OnInit, OnDestroy {

	@Input('autoComplete')
	set dropdownElements(dropdownElements: string[]) {
		this.dropdownElements$.next(dropdownElements || []);
	};

	private input: any;
	private dropdownElements$ = new ReplaySubject<string[]>(1);
	private dropdownPopper: any;
	private autocompleteSubscription: Subscription;
	private inputChangesSubscription: Subscription;
	private componentRef: ComponentRef<any>;

	private popperConfig = {
		placement: 'bottom',
		positionFixed: true,
		modifiers: {
			preventOverflow: {
				enabled: true,
				boundariesElement: 'window'
			},
			setWidth: {
				enabled: true,
				order: 840,
				fn(data) {
					data.offsets.popper.left = data.offsets.reference.left;
					data.offsets.popper.right = data.offsets.reference.right;
					data.offsets.popper.width = data.styles.width = Math.round(data.offsets.reference.width);
					return data;
				}

			}
		}
	};

	constructor(private element: ElementRef,
				private factoryResolver: ComponentFactoryResolver,
				private viewContainerRef: ViewContainerRef,
				private _changeDetectorRef: ChangeDetectorRef,
				private ngModel: NgModel,
	) {
	}

	ngOnInit() {
		fromEvent(document, "click", {passive: true}).pipe(
			filter(() => !!this.componentRef && this.componentRef.location.nativeElement.style.display !== 'none')
		)
			.subscribe((e: MouseEvent) => {
				if (!this.element.nativeElement.contains(e.target)) {
					this.componentRef.location.nativeElement.style.display = 'none'
				}
			})

		this._changeDetectorRef.detectChanges();
	}

	ngAfterContentInit() {
		if (this.ngModel) {
			this.input = this.ngModel.control

			this.autocompleteSubscription =
				combineLatest(this.dropdownElements$.asObservable(), fromEvent(this.element.nativeElement, "focus", {passive: true}), fromEvent(this.element.nativeElement, "keyup", {passive: true}))
					.subscribe(([arr, input, input2]: [string[], any, any]) => {

						console.log(arr,input,input2)
						if (!this.componentRef) {
							const factory: ComponentFactory<FangAutocompleteDropdownComponent> = this.factoryResolver.resolveComponentFactory(FangAutocompleteDropdownComponent);
							this.componentRef = this.viewContainerRef.createComponent(factory);
							this.componentRef.location.nativeElement.style.display = 'none';
							this.dropdownPopper = new Popper(this.element.nativeElement, this.componentRef.location.nativeElement, this.popperConfig as Popper.PopperOptions);
							this.inputChangesSubscription = this.componentRef.instance.onSelect.subscribe(v => {
								this.input.setValue(v);
							});
						}

						const inputValue = input.target.value;
						const lowerCaseInput = inputValue && inputValue.toLocaleLowerCase();
						const array = arr.slice().filter(e => e.toLowerCase().startsWith(lowerCaseInput));
						const lowerCaseArray = arr.slice().map(a => a.toLowerCase()).filter(e => e.startsWith(lowerCaseInput));

						if (inputValue && inputValue.length > 0 && (lowerCaseArray.length > 1 || !lowerCaseArray.includes(lowerCaseInput))) {
							this.componentRef.location.nativeElement.style.display = 'block';
							this.componentRef.instance.dropdownElements = array;
							this.componentRef.changeDetectorRef.detectChanges();
							this.dropdownPopper.scheduleUpdate();
						} else {
							this.componentRef.location.nativeElement.style.display = 'none';
						}
					})
		}
		this._changeDetectorRef.detectChanges();
	}

	ngOnDestroy() {
		this.dropdownPopper && this.dropdownPopper.destroy();
		this.autocompleteSubscription && this.autocompleteSubscription.unsubscribe();
		this.inputChangesSubscription && this.inputChangesSubscription.unsubscribe();
	}
}

